import { HttpService } from '@/api/shared/http.service'

import {
  Auto,
  AutoDTO,
  BookedSlot,
  CreateAutoResponse,
  CreateBookingDTO,
  CreateBookingResponse,
  ParkingSummary,
  ParkingTariff,
  QuickInterval,
  ReorderAutosDTO,
  TariffType
} from './parking.types'

class ParkingService extends HttpService {
  async getTariffs(projectId: string) {
    const { data } = await this.axios.get<{ data: ParkingTariff[] }>(
      this.getPath('/tariffs'),
      { params: { projectId } }
    )

    return data
  }

  async getQuickIntervals(projectId: string) {
    const { data } = await this.axios.get<{ data: QuickInterval[] }>(
      this.getPath('/quickIntervals'),
      { params: { projectId } }
    )

    return data
  }

  async getParkingSlots(
    projectId: string,
    type: TariffType,
    from: string,
    to: string,
    autoNumber?: string,
    isStandard?: boolean,
    personalAccountId?: string
  ) {
    const { data } = await this.axios.get<{ data: BookedSlot[] }>(
      this.getPath(`/slots/${type}`),
      {
        params: {
          projectId,
          type,
          from,
          to,
          autoNumber,
          isStandard,
          personalAccountId
        }
      }
    )

    return data
  }

  async getSummary(
    projectId: string,
    type: TariffType,
    from: string,
    to: string,
    autoNumber?: string,
    isStandard?: boolean,
    personalAccountId?: string
  ) {
    const { data } = await this.axios.get<ParkingSummary>(
      this.getPath('/summary'),
      {
        params: {
          projectId,
          type,
          from,
          to,
          autoNumber,
          isStandard,
          personalAccountId
        }
      }
    )

    return data
  }

  async createBooking(params: CreateBookingDTO) {
    return this.axios.post<CreateBookingResponse>(
      this.getPath('/bookings'),
      params
    )
  }

  async getAutos() {
    const { data } = await this.axios.get<{ data: Auto[] }>(
      this.getPath('/autos')
    )

    return data
  }

  async createAuto(params: AutoDTO) {
    return this.axios.post<CreateAutoResponse>(this.getPath('/autos'), params)
  }

  async updateAuto(id: string, params: AutoDTO) {
    return this.axios.put<null>(this.getPath(`/autos/${id}`), params)
  }

  async reorderAutos(params: ReorderAutosDTO) {
    return this.axios.put<null>(this.getPath('/autos/reorder'), params)
  }

  async deleteAuto(id: string) {
    return this.axios.delete<null>(this.getPath(`/autos/${id}`))
  }
}

const ParkingServiceSingleton = new ParkingService('/api/v1/parking')
export { ParkingServiceSingleton as ParkingService }
